import Axios from "axios";

class UsuarioDataService {
  updateSenha(params) {
    return Axios.put("/usuarios/profile", {
      id: params.id,
      senha: params.senha,
    });
  }

  updateFontSizePreference(tamanhoFonte) {
    return Axios.put("/usuarios/profile", { tamanhoFonte });
  }

  updateNotificationsPreference(permitirNotificacoes) {
    return Axios.put("/usuarios/profile", { permitirNotificacoes });
  }

  getPessoas() {
    return Axios.get("/pessoas");
  }

  getUser() {
    return Axios.get("usuarios/dados_Usuario");
  }

  getUserSimplified() {
    return Axios.get("usuarios/dados_Usuario/simplified");
  }

  getAll() {
    return Axios.get("usuarios");
  }

  getPermissoes() {
    return Axios.get("usuarios/permissoes");
  }

  update(params) {
    return Axios.put(`usuarios/${params.id}`, params);
  }

  changeTenant(idUsuario, idInquilino) {
    return Axios.put(`usuarios/changeTenant/${idUsuario}/${idInquilino}`);
  }

  changePasswordRandomly(params) {
    return Axios.put(`usuarios/changePasswordRandomly/${params.id}`);
  }

  getDispositivosConfiaveis() {
    return Axios.get(
      "usuarios/autenticacao-dois-fatores/dispositivos-confiaveis"
    );
  }

  registrarDispositivoConfiavel(params) {
    return Axios.post(
      "usuarios/autenticacao-dois-fatores/dispositivos-confiaveis",
      params
    );
  }

  iniciarRegistroPasskey(params) {
    return Axios.post(
      "usuarios/autenticacao-dois-fatores/passkeys/registro/iniciar",
      params
    );
  }

  finalizarRegistroPasskey(params) {
    return Axios.post(
      "usuarios/autenticacao-dois-fatores/passkeys/registro/finalizar",
      params
    );
  }

  removerDispositivoConfiavel(id) {
    return Axios.delete(
      `usuarios/autenticacao-dois-fatores/dispositivos-confiaveis/${id}`
    );
  }

  removerPasskey(id) {
    return Axios.delete(`usuarios/autenticacao-dois-fatores/passkeys/${id}`);
  }

  clonarPerfis(params) {
    return Axios.put("usuarios/clonarPerfis", params);
  }

  findPerfisParaClonagem(id) {
    return Axios.get(`usuarios/${id}/perfis-clonagem`);
  }

  findInquilinosReplicacaoPerfis(id) {
    return Axios.get(`usuarios/${id}/perfis-replicacao`);
  }

  create(params) {
    return Axios.post("usuarios", params);
  }

  getPage(params) {
    return Axios.get("usuarios/page", { params });
  }

  delete(id) {
    return Axios.delete(`usuarios/${id}`);
  }

  find(id) {
    return Axios.get(`usuarios/${id}`);
  }

  findPermissoes() {
    return Axios.get("usuarios/permissoes");
  }

  findPerfis() {
    return Axios.get("usuarios/perfis");
  }

  getFilter(params) {
    return Axios.post("usuarios/filter", params);
  }

  getFilterPage(payload, params) {
    return Axios.post("usuarios/filter/page", payload, { params });
  }

  createPessoa(params) {
    return Axios.post("/pessoas", params);
  }

  changeMyTokenWeb(params) {
    return Axios.post("/pessoas/registerMyPushTokenWeb", params);
  }
}
export default new UsuarioDataService();
